module.exports = __webpack_public_path__ + "static/media/PH3800_001_Spooky.0ae1a59b.mp3";